import { useEffect, useState, useRef } from "react";
import { BASE_URL } from "../constant/apiUrl";
import { getAPI } from "../API/ApiService";
import { showErrorToast } from "../utils/Toast/toast";
import { getActiveItems } from "../utils/function";
import { useDispatch, useSelector } from "react-redux";
import {
  setSectorFilter,
  setCountryFilter,
  setVarietyFilter,
  setFlashColorFilter,
  setIpOwnerShipFilter,
  setRegionFilter,
  setLanguageFilter,
  setSubjectFilter,
  setCropTypeFilter,
  setContentLevel,
  setVisibility,
  setSpecialProjects,
  setPeriods,
  setDisclaimers,
} from "../slices/internalFilterSlice";
import axios from "axios";
const lookUpTypes = [
  "SECTOR",
  "FLESH_COLOR",
  "COUNTRY",
  "REASON_FOR_ACCESS",
  "IPOWNERSHIP",
  "REGION",
  "CROP_TYPE",
  "SPECIAL_PROJECTS",
  "VISIBILITY",
  "CONTENT_LEVEL",
  "DISCLAIMER",
  "PERIOD",
  "LANGUAGE",
];

function buildLookupUrl(lookUpTypes = []) {
  if (!lookUpTypes.length) {
    return `${BASE_URL}/lookup/find-all`;
  }

  const params = lookUpTypes.map(
    (type) => `lookUpTypes=${encodeURIComponent(type)}`
  );

  return `${BASE_URL}/lookup/find-all?${params.join("&")}`;
}

const useLookupData = (lookUpType, dependancy = null) => {
  const [sectorData, setSectorData] = useState([]);
  const [countryData, setCountryData] = useState([]);
  const [fleshColorData, setFleshColorData] = useState([]);
  const [user, setUser] = useState([]);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const dispatch = useDispatch();
  const { reload } = useSelector((store) => store.internalFilter);

  // ✅ Ref to track if a lookUpType was already fetched
  const fetchedRef = useRef({});

  useEffect(() => {
    const fetchLookupData = async () => {
      if (fetchedRef.current[lookUpType]) return;
      fetchedRef.current[lookUpType] = true;

      setLoading(true);
      setError(null);
      try {
        const url = buildLookupUrl(lookUpTypes);
        const response = await getAPI(url);

        if (response.status === 200) {
          let result = response?.data?.response;

          dispatch(setSectorFilter(getActiveItems(result?.SECTOR)));
          setSectorData(getActiveItems(result?.SECTOR));
          dispatch(setCountryFilter(getActiveItems(result?.COUNTRY)));
          setCountryData(getActiveItems(result?.COUNTRY));
          dispatch(setFlashColorFilter(getActiveItems(result?.FLESH_COLOR)));
          setFleshColorData(getActiveItems(result?.FLESH_COLOR));
          setUser(getActiveItems(result?.REASON_FOR_ACCESS));
          dispatch(setIpOwnerShipFilter(getActiveItems(result?.IPOWNERSHIP)));
          dispatch(setRegionFilter(getActiveItems(result?.REGION)));
          dispatch(setLanguageFilter(getActiveItems(result?.LANGUAGE)));
          dispatch(setCropTypeFilter(getActiveItems(result?.CROP_TYPE)));
          dispatch(
            setSpecialProjects(getActiveItems(result?.SPECIAL_PROJECTS))
          );
          dispatch(setVisibility(getActiveItems(result?.VISIBILITY)));
          dispatch(setContentLevel(getActiveItems(result?.CONTENT_LEVEL)));
          dispatch(setDisclaimers(getActiveItems(result?.DISCLAIMER)));
          dispatch(setPeriods(getActiveItems(result?.PERIOD)));
        }

        if (response?.status === 500) {
          showErrorToast(`Failed to load ${lookUpType}`);
        }
      } catch (err) {
        console.log(err);

        showErrorToast(`Something went wrong`);
      } finally {
        setLoading(false);
      }
    };

    fetchLookupData();
  }, [dependancy, reload]);

  return {
    sectorData,
    countryData,
    fleshColorData,
    loading,
    error,
    setLoading,
    user,
  };
};

export default useLookupData;
